export default __webpack_public_path__ + "static/6-be380b4f42a1c7ee3a7337dac65b1971.png";